import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {FilterStore, UserStore} from '../../../stores';
import {BaseRouteProps} from '../../../interfaces';
import {IndividualReportBlock} from '../blocks/IndividualReportBlock';
import {ReportDataService, StyleDataService} from '../../../services';
import {LoadingIndicator} from '../../loadingIndicator/LoadingIndicator';
import {ReportType} from '../../../enums';
import {PVAStyle} from "../blocks";
import {PdfBrief} from "./pdf_brief";
import {Style} from "../../../models";

interface PdfBriefPreviewProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

interface PdfBriefPreviewState {
    loading: boolean;
    selectedUserData: any;
    allStyles: Style[];
}

@inject('UserStore', 'FilterStore')
@observer
export class PdfBriefPreview extends React.Component<PdfBriefPreviewProps, PdfBriefPreviewState> {
    private reportDataService = new ReportDataService(this.props.notificationService);
    private styleDataService = new StyleDataService(this.props.notificationService);
    
    constructor(props: PdfBriefPreviewProps) {
        super(props);
        this.state = {
            loading: true,
            selectedUserData: null,
            allStyles: []
        };
    }

    public componentDidMount() {
        const user = this.props.UserStore && this.props.UserStore.userInfo;
        const loggedInUserId = user ? user.id : undefined;
        const surveyVersion = this.props.FilterStore && this.props.FilterStore.surveyVersion;

        if (loggedInUserId && surveyVersion) {
            Promise.all([
                this.reportDataService.getIndividualReportDataLatestBySurveyVersion(loggedInUserId, surveyVersion.id),
                this.styleDataService.getAllBySurveyVersionId(surveyVersion.id)
            ]).then(([selectedUserData, allStyles]) => {
                this.setState({ selectedUserData, allStyles, loading: false });
            }).catch(() => {
                this.setState({ loading: false });
            });
        } else if (loggedInUserId) {
            this.reportDataService.getIndividualReportDataLatest(loggedInUserId)
                .then((selectedUserData) => {
                    if (selectedUserData && selectedUserData.style && selectedUserData.style.surveyVersionID) {
                        this.styleDataService.getAllBySurveyVersionId(selectedUserData.style.surveyVersionID)
                            .then((allStyles) => {
                                this.setState({ selectedUserData, allStyles, loading: false });
                            })
                            .catch(() => {
                                this.setState({ selectedUserData, loading: false });
                            });
                    } else {
                        this.setState({ selectedUserData, loading: false });
                    }
                })
                .catch(() => {
                    this.setState({ loading: false });
                });
        } else {
            this.setState({ loading: false });
        }
    }

    public render() {
        console.log(`render`);
        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        const user = this.props.UserStore && this.props.UserStore.userInfo;
        const loggedInUserId = user ? user.id : undefined;

        if (!loggedInUserId) {
            return <div>Please log in to see the brief preview.</div>;
        }

        if (!this.state.selectedUserData) {
            return <div>No report data found for your user. Please ensure you have completed a survey.</div>;
        }

        const surveyVersion = (this.props.FilterStore && this.props.FilterStore.surveyVersion) || this.state.selectedUserData.surveyVersion;

        return (
            <div className="pdf-preview-container" style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
                <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#fff', border: '1px solid #ccc' }}>
                    <strong>PDF Brief Preview Mode</strong> (Superadmin only)
                </div>
                <div className="pdf-content-wrapper" style={{ backgroundColor: '#fff', boxShadow: '0 0 10px rgba(0,0,0,0.1)', width: '800px', margin: '0 auto', padding: '20px' }}>
                    <PdfBrief 
                        {...this.props}
                        selectedUserData={this.state.selectedUserData}
                        allStyles={this.state.allStyles}
                        surveyVersion={surveyVersion}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/individual/PdfBriefPreview.tsx